import isFunction from "@homer.utility/validator.isfunction";

const matchClass = /^class\s*/;

const isClass = (value) => {
    return isFunction(value) && matchClass.test(value.toString());
};

export default isClass;
